// removed by extract-text-webpack-plugin
module.exports = {"menu":"sBqo2oXC8H3OTAUsAQILX","close":"_1oIgjeywRqVrv6XhlHToYh","item":"_1izN4XwAPMmB1GRlUL3ute","menuItems":"_3C4aZ09IvWoXZrsvGhzJ71","yadda":"_1QVcqH2_v8zjVe9LsthCNh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileMenu/MobileMenu.module.scss
// module id = 790
// module chunks = 0